import * as profileActions from './profileActions';
import profileReducer from './profileReducer';
import profileSagas from './profileSagas';
import * as profileSelectors from './profileSelectors';
import * as profileTypes from './profileTypes';

const { PROFILE_REDUCER_KEY } = profileTypes;

const PROFILE_VERSION_NUMBER = 2;

export {
  PROFILE_REDUCER_KEY,
  profileTypes,
  profileActions,
  profileSagas,
  profileReducer,
  profileSelectors,
  PROFILE_VERSION_NUMBER,
};
